// Module
var code = "<pending-gp-letters></pending-gp-letters>";
// Exports
var _module_exports =code;;
var path = 'app/views/users/gp-letters/tabs/pending-gp-letters/pending-gp-letters.component.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;